import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TableText } from "styledComponents/common";

import Chat from "../../../assets/img/icons/chat.svg";
import Bean from "../../../assets/img/icons/delete_normal.svg";
import Pencil from "../../../assets/img/icons/edit-2.svg";
import TaskActionTooltip from "../../../components/Tooltip/TaskActionTooltip";
import { ButtonIcon } from "../../../styledComponents/buttons";
import { CommonFlexIcon, CommonImage } from "../../../styledComponents/common";
import { IconButtonHolder } from "../tasksStyles";
import {
  SubTaskTableHeaderContainer,
  SubTaskTableRowContainer,
} from "./createTaskStyles";

const {
  RoundHover,
  HoveredSection2,
  TooltipText,
  InnerDivTooltip,
  ToolTipContainer,
} = require("styledComponents/clients");
const { TableItem } = require("styledComponents/teams");

const SubTaskTable = ({
  subTaskList,
  setSubTaskList,
  onEditSubTask,
  onDeleteSubTask,
}) => {
  const { t } = useTranslation();
  const [selectIndex, setSelectIndex] = useState(-1);
  const [toolTip, setToolTip] = useState(-1);

  const toolTipChange = (value, index) => {
    setToolTip(value);
    setSelectIndex(index);
  };

  const handleDelete = identifier => {
    if (onDeleteSubTask) {
      onDeleteSubTask(identifier);
    } else {
      const updatedList = subTaskList.filter((task, currentIndex) => {
        if (task.id) {
          return task.id !== identifier;
        }
        return currentIndex !== identifier;
      });
      setSubTaskList(updatedList);
    }
  };

  const handleEdit = identifier => {
    if (onEditSubTask && identifier) {
      onEditSubTask(identifier);
    }
  };
  return (
    <>
      <SubTaskTableHeaderContainer>
        <TableItem>
          <TableText>#</TableText>
        </TableItem>
        <TableItem>
          <TableText>Subtask Name</TableText>
        </TableItem>
        <TableItem>
          <TableText>Subtask Description</TableText>
        </TableItem>
        <TableItem>
          <TableText>Require Evidence</TableText>
        </TableItem>
        <TableItem>
          <TableText>Actions</TableText>
        </TableItem>
      </SubTaskTableHeaderContainer>

      {subTaskList.map((subTask, index) => (
        <SubTaskTableRowContainer
          key={subTask.id || index}
          isLastItem={index === subTaskList.length - 1}
        >
          <TableItem>
            <TableText>{index + 1}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{subTask.name}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{subTask.description}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{subTask.isAllowedEvidences ? "Yes" : "No"}</TableText>
          </TableItem>
          <TableItem>
            <CommonFlexIcon gap="0px">
              <IconButtonHolder
                onMouseEnter={() => toolTipChange(1, index)}
                onMouseLeave={() => toolTipChange(-1)}
                onClick={() => handleEdit(subTask.id)}
              >
                <CommonImage src={Pencil} alt="pencil" size="24px" />
                {selectIndex === index && toolTip === 1 && (
                  <TaskActionTooltip toolTipText={t("edit")} />
                )}
              </IconButtonHolder>
              <IconButtonHolder
                onMouseEnter={() => toolTipChange(3, index)}
                onMouseLeave={() => toolTipChange(-1)}
                onClick={() => handleDelete(subTask.id ?? index)}
              >
                <CommonImage src={Bean} alt="" size="24px" />
                {selectIndex === index && toolTip === 3 && (
                  <TaskActionTooltip toolTipText={t("delete")} />
                )}
              </IconButtonHolder>
            </CommonFlexIcon>
          </TableItem>
        </SubTaskTableRowContainer>
      ))}
    </>
  );
};
export default SubTaskTable;
